module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ja_kyushu-463c51fdf803b0faf55980ca615155df.jpg";